<template>
  <b-container>
    <h3>Forgot Password</h3>
    <b-alert :variant="validationMessageType" :show="showValidationMessage"> {{validationMessage}} </b-alert>

    <b-form @submit.prevent="forgotPassword">
      <b-form-group
                    label="Username">
        <b-form-input 
                      v-model="username"
                      required
                      placeholder="Enter your username">
        </b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" :disabled="processing">Request Password Reset</b-button>
    </b-form>
  </b-container>
</template>

<script>
import AuthService from "../../services/AuthService";

export default {
  name: "ForgotPassword",
  data() {
    return {
      username: "",
      showValidationMessage : false,
      validationMessageType: "info",
      validationMessage : "",
      processing: false
    };
  },
  methods: {
    forgotPassword() {
      if(this.username) {
        this.processing = true;
        AuthService.ForgotPassword(this.username).then(() => {
          this.validationMessageType = 'info'
          this.validationMessage = "Password reset email sent";
          this.showValidationMessage = true;
        });
      }
      else{
        this.validationMessageType = 'error'
        this.validationMessage = "Username requried";
        this.showValidationMessage = true;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/auth/forgot.vue